import { useState, ReactNode, useCallback } from 'react';
import { LayoutContext, BackButtonConfig } from './LayoutContext';

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
    const [showFooter, setShowFooter] = useState(true);
    const [backButton, setBackButtonState] = useState<BackButtonConfig | undefined>(undefined);
    const [mainContentBackgroundClass, setMainContentBackgroundClassState] = useState<string | undefined>(undefined);

    const setBackButton = useCallback((config: BackButtonConfig | undefined) => {
        setBackButtonState(config);
    }, []);

    const setMainContentBackgroundClass = useCallback((className: string | undefined) => {
        setMainContentBackgroundClassState(className);
    }, []);

    return (
        <LayoutContext.Provider value={{
            showFooter,
            setShowFooter,
            backButton,
            setBackButton,
            mainContentBackgroundClass,
            setMainContentBackgroundClass,
        }}
        >
            {children}
        </LayoutContext.Provider>
    );
};
